import { Reducer } from "redux";

import { NtuReasonMasterActionDispatchTypes } from "../constants/Master";
import { NtuReasonMasterDispatchTypes } from "../models/DispatchTypes/Master";
import { NtuReasonMasterResponse } from "../models/Api/Master";

export const initialState: NtuReasonMasterResponse = {
  loading: false,
  response: [],
};

const MasterNtuReasonReducer: Reducer<
  NtuReasonMasterResponse,
  NtuReasonMasterDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_ERROR: {
      return initialState
    }
  }
  return state;
};

export default MasterNtuReasonReducer;
